import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDatePipe'
})
export class CustomDatePipePipe implements PipeTransform {

  public monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  public days       = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  public shortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
  public shortDays       = ['Sun', 'Mon', 'Tues', 'Wednes', 'Thurs', 'Fri', 'Satur'];

  transform(value: any, type = "") {
    if(value) {
      // if(typeof value == 'object')
      //   value = this.caonvertDateToString(value);

      if(typeof value == 'string') {
        value = value.replace(/\s/g, "T");
      }
      const d = new Date(value);

      switch (type) {
        case 'onlyDay':
          return this.days[d.getDay()];
          break;
        case 'onlyTime':
          return this.formatAMPM(value);
          break;
        case 'shortMonth':
          return this.shortMonthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
          break;
        case 'yyyy-mm-dd hh:mm':
          return d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + ' ' + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + ((d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes());
          break;
        case 'shortTime':
          return this.monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear() + ' ' + this.formatAMPM(value);
          break;
        case 'monthYear':
          return this.monthNames[d.getMonth()] + ', ' + d.getFullYear();
          break;
        case 'dateTime':
          return d.getDate() + '-' + this.shortMonthNames[d.getMonth()] + ' ' + d.getFullYear() + ' ' + this.formatAMPM(value);
          break;
        case 'dayMonth':
          return d.getDate() + ' ' + this.monthNames[d.getMonth()];
          break;
        default:
          return this.monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
          break;
      }
    }
    return;
  }

  formatAMPM(date) {
    date = new Date(date);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  caonvertDateToString(timestamp){
    var x = new Date(timestamp);
    var dd = x.getDate();
    var mm = x.getMonth()+1;
    var yy = x.getFullYear();
    return yy +"-" + mm+"-" + dd;
  }

  getCurrentDateTimeToString(dateObj) {
    var date = new Date(dateObj);

    var yr   = date.getFullYear();
    var mon  = date.getMonth() + 1;
    var mo   = mon < 10 ? '0' + mon : mon;
    var dayI = date.getDate();
    var day  = dayI < 10 ? '0' + dayI : dayI;

    var hours = date.getHours();
    var hr = hours < 10 ? '0' + hours : hours;

    var minutes = date.getMinutes();
    var min = (minutes < 10) ? '0' + minutes : minutes;

    var seconds = date.getSeconds();
    var sec = (seconds < 10) ? '0' + seconds : seconds;

    var newDateString = yr + '-' + mo  + '-' + day;
    var newTimeString = hr + ':' + min + ':' + sec;

    // 2021-07-01T19:00:00.000Z
    // 2021-07-01T00:00:00
    // 2021-07-01T00:00:00.000Z
    // return newDateString + 'T' + newTimeString + '.000Z';
    return newDateString + 'T' + newTimeString;
  }
}
